import React, { useEffect } from 'react'
import { LoginCallback } from '@okta/okta-react'
import { useStores } from '../hooks/useStores'
import { OktaError } from '../../components/okta-error'
import { parse } from 'query-string'
import { parseJsonSafe } from '../../helpers/general-helpers'
import { OauthCustomState } from '../../modules/auth/login/login.helpers'
import { RouteProps } from 'react-router-dom'

export const CustomLoginCallback = (props: RouteProps) => {
  const appStore = useStores()

  useEffect(() => {
    const params = parse(location.search) as { state?: string }
    const parsedState: OauthCustomState = parseJsonSafe(params?.state)

    if (params?.state && parsedState?.appId) {
      appStore.authStore.setIdpRedirectAppId(parsedState.appId)
    }

    if (params?.state && parsedState?.redirectUrl) {
      appStore.authStore.setIdpRedirectUrl(parsedState.redirectUrl)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <LoginCallback {...props} errorComponent={OktaError} />
}
